module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-3-1ac41e48ad064541ed8f1dca9e8c5def.svg";